import type { SessionMachineState } from 'state-machines/session';

export const selectIsLoggingOut = (state: SessionMachineState) =>
	// waitForRefresh can be during login as well, but this selector will
	// hopefully only be used in situations where the user is already logged in,
	// meaning the 'currently logging in' state won't be relevant anyway.
	state.hasTag('logout') || state.matches('delayedBrowserRefresh');

export const selectIsAuthenticatedUser = (state: SessionMachineState) =>
	state.matches('authenticatedUser');

export const selectIsInitialisingUser = (state: SessionMachineState) =>
	state.hasTag('initialisation');
